import React, { useEffect, useState } from "react";
import MembershipRenewalView from "./MembershipRenewalView";

import { CheckGreenIcon, CalendarRedIcon, DangerRedIcon, CloseRedIcon, DollarBlueIcon, FilterIcon } from "../../../assets/icons";
import { LocalPlanSubscriptionInfo } from "../../../models/local/local.response";
import { useNotification } from "../../toster-notification/NotificationContext";
import { localService } from "../../../services/localService";
import { handleErrorNotification } from "../../../utils/errorNotificatioMessage";
import { ToLocalDateTimeString } from "../../../utils/dateFormater";
import CancelSubscriptionView from "./CancelSubscriptionView";

const SubscriptionPage: React.FC = () => {

    const [isMembershipRenewalViewOpen, setIsMembershipRenewalViewOpen] = useState(false);
    const [isCancelSubscriptionViewOpen, setIsCancelSubscriptionViewOpen] = useState(false);

    const [localName, setLocalName] = useState<string>("");
    const [selectedLocalId, setSelectedLocalId] = useState<string>("");
    const [selectedSubscriptionId, setSelectedSubscriptionId] = useState<string>("");

    const [filterText, setFilterText] = useState<string>("");

    const [localsPlanSubscriptionInfo, setLocalsPlanSubscriptionInfo] = useState<LocalPlanSubscriptionInfo[]>([]);

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();


    useEffect(() => {
        fetchLocalsPlanSubscriptionInfo();
    }, []);


    const fetchLocalsPlanSubscriptionInfo = async () => {
        setLoading(true);
        try {
            const response = await localService.getLocalsPlanSubscriptionInfo();

            if (response.success && response.data) {
                setLocalsPlanSubscriptionInfo(response.data);
            } else {
                notify("error", response.message || "Greška pri učitavanju informacija o članarinama lokala");
            }
        } catch (error) {
            notify("error", "Greška pri učitavanju informacija o članarinama lokala");
            handleErrorNotification(error, notify);
        }
        finally {
            setLoading(false);
        }
    };

    const statusClassName = (status: boolean) => {
        switch (status) {
            case true:
                return "green-bg";
            case false:
                return "red-bg";
            default:
                return "grey-bg";
        }
    }

    const daysLeftClassName = (daysLeft: number | null) => {
        if (daysLeft === null) {
            return "grey-bg";
        } else if (daysLeft <= 5) {
            return "red-bg";
        } else if (daysLeft <= 14) {
            return "dark-red-bg";
        } else {
            return "black-bg";
        }
    }

    const daysLeft = (endAt : string) => {
        return Math.ceil((new Date(endAt).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
    }

    const isLessThanDays = (endAt: string | undefined, days: number): boolean => {
        if (!endAt) {
            return false;
        }
        const daysRemaining = Math.ceil((new Date(endAt).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
        return daysRemaining < days && daysRemaining >= 0;
    }

    return (
        <>
            {isMembershipRenewalViewOpen && (
                <MembershipRenewalView
                    localName={localName}
                    localId={selectedLocalId}
                    onClose={() => {
                        setIsMembershipRenewalViewOpen(false)
                        fetchLocalsPlanSubscriptionInfo();
                    }} />
            )}

            {isCancelSubscriptionViewOpen && (
                <CancelSubscriptionView 
                    onClose={() => {
                        setIsCancelSubscriptionViewOpen(false)
                        fetchLocalsPlanSubscriptionInfo();
                    }}
                    id={selectedSubscriptionId}
                    />

            )}

            <section className="sa-subscription-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="sttings-content-wrapper">
                        <div className="header-div">
                            <div>
                                <h2 className="heading-3">Upravljanje Članarinama</h2>
                                <div className="text-block">
                                    Pregled i upravljanje aktivnim članarinama<br />
                                </div>
                            </div>
                        </div>
                        <div className="list-stats-block-div">
                            <div className="admin-settings-box-div subscription">
                                <div className="sa-subscription-active-info">
                                    <div>Aktivne Članarine</div>
                                    <div className="list-stats-number-text">{localsPlanSubscriptionInfo.filter(info => info.isActivePlanSubscription).length}</div>
                                </div>
                                <div className="div-block-11">
                                    <img loading="lazy" src={CheckGreenIcon} alt="" className="icon-size-20" />
                                </div>
                            </div>
                            <div className="admin-settings-box-div subscription expire-soon">
                                <div className="sa-subscription-active-info">
                                    <div>Ističu Uskoro</div>
                                    <div className="list-stats-number-text">{ localsPlanSubscriptionInfo.filter(info => isLessThanDays(info.planEndAt, 10)).length}<span className="text-block-8">&lt;10 dana</span>
                                    </div>
                                </div>
                                <div className="div-block-11 expired-soon">
                                    <img loading="lazy" src={CalendarRedIcon} alt="" className="icon-size-20" />
                                </div>
                            </div>
                            <div className="admin-settings-box-div subscription critical">
                                <div className="sa-subscription-active-info">
                                    <div>Kritično</div>
                                    <div className="list-stats-number-text alert-fc">{localsPlanSubscriptionInfo.filter(info => isLessThanDays(info.planEndAt, 5)).length}<span className="text-block-8">&lt;5 dana</span>
                                    </div>
                                </div>
                                <div className="div-block-11 alert">
                                    <img loading="lazy" src={DangerRedIcon} alt="" className="icon-size-20" />
                                </div>
                            </div>
                            <div className="admin-settings-box-div subscription">
                                <div className="sa-subscription-active-info">
                                    <div>Istekle</div>
                                    <div className="list-stats-number-text">{localsPlanSubscriptionInfo.filter(info => isLessThanDays(info.planEndAt, 0)).length}</div>
                                </div>
                                <div className="div-block-11 expired">
                                    <img loading="lazy" src={CloseRedIcon} alt="" className="icon-size-20" />
                                </div>
                            </div>
                            <div id="w-node-_784b75b9-7580-94fe-59b3-83eda5076e8c-1cee91cf" className="admin-settings-box-div subscription">
                                <div className="sa-subscription-active-info">
                                    <div>Ukupan prihod</div>
                                    <div className="list-stats-number-text"> //TO DO 23,000 RSD</div>
                                </div>
                                <div className="div-block-11 profit">
                                    <img loading="lazy" src={DollarBlueIcon} alt="" className="icon-size-20" />
                                </div>
                            </div>
                        </div>

                        <div className="admin-settings-box-div table-block-div">
                            <div className="list-header">
                                <div className="list-header-info">
                                    <div className="list-header-title">Članarine</div>
                                    <div className="list-header-description">
                                        Pregled svih članarina u sistemu<br />
                                    </div>
                                </div>
                                <div className="list-header-filer">
                                    <img loading="lazy" src={FilterIcon} alt="" className="icon-size-20" />
                                    <div className="list-header-filer-form w-form">
                                        <form className="form">
                                            <input className="form-input w-input" placeholder="Pretrazi lokacije/vlasnike..." type="text"
                                                value={filterText}
                                                onChange={(e) => setFilterText(e.target.value)}
                                            />
                                            <select className="form-select w-select">
                                                <option value="">Sve članarine</option>
                                            </select>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="list-div">
                                <div className="list-row-div list-header-row subscription">
                                    <div>Lokacija</div>
                                    <div>Vlasnik</div>
                                    <div>Plan</div>
                                    <div>Period</div>
                                    <div>Status</div>
                                    <div>Preostalo</div>
                                    <div id="w-node-_784b75b9-7580-94fe-59b3-83eda5076eb6-1cee91cf">Akcije</div>
                                </div>

                                {localsPlanSubscriptionInfo
                                .filter(local => 
                                    local.name.toLowerCase().includes(filterText.toLowerCase()) || 
                                    local.ownerName.toLowerCase().includes(filterText.toLowerCase())
                                )
                                .map((local) => (
                                    <div className="list-row-div subscription" key={local.id}>

                                        <div>{local.name}</div>

                                        <div>{local.ownerName}</div>

                                        <div className="small-box-div">
                                            <div>{local.planName ?? "N/A"}</div>
                                        </div>

                                        <div>
                                            {local.planStartAt ? ToLocalDateTimeString(local.planStartAt) : '/'} <br />- {local.planEndAt ? ToLocalDateTimeString(local.planEndAt) : '/'}
                                        </div>

                                        <div className={`small-box-div ${statusClassName(local.isActivePlanSubscription ?? false)}`}>
                                            {local.isActivePlanSubscription ? 'Aktivna' : 'Istekla'}
                                        </div>

                                        <div className={`small-box-div ${daysLeftClassName(local.planEndAt ? Math.ceil((new Date(local.planEndAt).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)) : null)}`}>
                                            <div>{local.planEndAt ? Math.ceil((new Date(local.planEndAt).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)) + " dana" : "N/A"}</div>
                                        </div>

                                        <div id="w-node-_784b75b9-7580-94fe-59b3-83eda5076eca-1cee91cf" className="table-row-action-btns-div">

                                            {!local.planEndAt ? (
                                                <div className="small-box-div black-bg pointer"
                                                    onClick={() => {
                                                        setLocalName(local.name);
                                                        setSelectedLocalId(local.id);
                                                        setIsMembershipRenewalViewOpen(true);
                                                    }}>
                                                    <div>Kreiraj</div>
                                                </div>
                                            ) : (
                                                new Date(local.planEndAt || '') < new Date() ? (
                                                    <div className="small-box-div green-bg pointer"
                                                        onClick={() => {
                                                            setLocalName(local.name);
                                                            setSelectedLocalId(local.id);
                                                            setIsMembershipRenewalViewOpen(true);
                                                        }}>
                                                        <div>Obnovi</div>
                                                    </div>
                                                ) : (
                                                    <div className="small-box-div pointer"
                                                        onClick={() => {
                                                            setIsCancelSubscriptionViewOpen(true);
                                                            setSelectedSubscriptionId(local.planSubscriptionId || '');
                                                        }}
                                                    >
                                                        <div>Otkaži</div>
                                                    </div>
                                                )
                                            )}
                                        </div>

                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>
            </section >

        </>
    );
};

export default SubscriptionPage;